goog.provide("shadow.js.shim.module$mime$lite");
goog.provide("module$shadow_js_shim_module$mime$lite");
shadow.js.shim.module$mime$lite = shadow.js.nativeProvides["mime/lite"] = shadow$bridge("mime/lite");
module$shadow_js_shim_module$mime$lite.default = shadow.js.shim.module$mime$lite;
